import React, { useEffect } from 'react';
import { FormInputsData, UserTypes, UserRoles } from '../../data/CreateUserData';
import { Tabs } from '../../data/UsersData';
import { FormCustom, TabCustom } from '../common';
import { commonFn } from '../../util/commonFn';
import { createUser } from '../../redux/users/action';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

export const CreateUser = ({ isEdit, isView, match }) => {
  const { createUserProcess, createUserError, createUserData } = useSelector(({ users }) => ({
    ...users,
  }));
  const dispatch = useDispatch();
  const { push } = useHistory();

  // form data
  const formData = {
    list: FormInputsData,
    userTypes: UserTypes,
    userRoles: UserRoles,
    isEdit,
    isView,
  };

  // tabs data
  const tabs = {
    ...Tabs,
    list: commonFn.updateLink(Tabs.list, match),
  };

  // form submit action
  const formSubmit = (data) => {
    dispatch(createUser(data));
  };

  useEffect(() => {
    if (!createUserProcess && !createUserError && createUserData) {
      push(`/users`);
    }
  }, [createUserProcess, createUserError, createUserData]);

  return (
    <>
      <TabCustom {...tabs} />
      <FormCustom {...formData} formSubmit={formSubmit} />
    </>
  );
};

export default CreateUser;
